import {
  INITIATE_APPLICATION_CONTEXT, INVALIDATE_ASSETS_SELECTION, INVALIDATE_SETTINGS, SELECT_WIDGET, UPDATE_ADVANCE_SETTINGS, SET_ACTIVE_CRM,
  SET_ACTIVE_TAB,
  ACTIVATED_GMAIL_INTEGRATION
} from 'constants/actionTypes';

import { createAction } from 'redux-actions';

export const initiateApplicationContext = createAction(INITIATE_APPLICATION_CONTEXT);

export const selectWidget = createAction(SELECT_WIDGET);

export const updateAdvanceSettings = createAction(UPDATE_ADVANCE_SETTINGS);

export const invalidateAssetSelection = createAction(INVALIDATE_ASSETS_SELECTION);

export const invalidateSettings = createAction(INVALIDATE_SETTINGS);

export const setActiveCRM  = createAction(SET_ACTIVE_CRM)

export const setActiveTab  = createAction(SET_ACTIVE_TAB);

export const activatedGmailIntegration = createAction(ACTIVATED_GMAIL_INTEGRATION);